export var SettingsItem;
(function (SettingsItem) {
    SettingsItem["FLIGHT_ROUTE"] = "FLIGHT_ROUTE";
    SettingsItem["AUTOMATIC_REFRESH"] = "AUTOMATIC_REFRESH";
    SettingsItem["DISPLAY_ACTIVE_AIRPORTS"] = "DISPLAY_ACTIVE_AIRPORTS";
})(SettingsItem || (SettingsItem = {}));
export var Settings;
(function (Settings) {
    function get(item) {
        return localStorage.getItem(item);
    }
    Settings.get = get;
    function set(item, value) {
        return localStorage.setItem(item, `${value}`);
    }
    Settings.set = set;
})(Settings || (Settings = {}));
